import { useCallback, useSyncExternalStore } from 'react';

/** Subscribes to a media query. Without matchMedia (tests, SSR) it returns `fallback`. */
export function useMediaQuery(query: string, fallback = false): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () =>
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia(query).matches
        : fallback,
    () => fallback,
  );
}

/** Phone layout (below Tailwind's md breakpoint). */
export const usePhone = () => useMediaQuery('(max-width: 47.99rem)');
